import { render, staticRenderFns } from "./TipoEstudio.vue?vue&type=template&id=0fe73966&"
import script from "./TipoEstudio.vue?vue&type=script&lang=js&"
export * from "./TipoEstudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports